import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const VideosGamesIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "VideosGamesIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.0339 3.93652H3.22571C2.90259 3.93652 2.64062 4.19848 2.64062 4.5216V17.9074C2.64062 18.2305 2.90259 18.4925 3.22571 18.4925H7.49443V19.6133H6.05374C5.73062 19.6133 5.46866 19.8752 5.46866 20.1984C5.46866 20.5215 5.73062 20.7834 6.05374 20.7834H19.2058C19.5289 20.7834 19.7909 20.5215 19.7909 20.1984C19.7909 19.8752 19.5289 19.6133 19.2058 19.6133H17.7651V18.4925H22.0339C22.357 18.4925 22.6189 18.2305 22.6189 17.9074V4.5216C22.6189 4.19848 22.357 3.93652 22.0339 3.93652ZM16.5949 19.6133H8.66458V18.4925H16.5949L16.5949 19.6133ZM21.4488 17.3223H3.81079V5.10668H21.4488V17.3223Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.6261 16.4504C12.9492 16.4504 13.2112 16.1885 13.2112 15.8654C13.2112 15.5422 12.9492 15.2803 12.6261 15.2803C12.303 15.2803 12.041 15.5422 12.041 15.8654C12.041 16.1885 12.303 16.4504 12.6261 16.4504Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.40295 11.0549H9.10309V11.6818C9.10309 12.005 9.36505 12.2669 9.68817 12.2669C10.0113 12.2669 10.2733 12.005 10.2733 11.6818V11.0549H10.9348C11.2579 11.0549 11.5199 10.793 11.5199 10.4699C11.5199 10.1467 11.2579 9.88478 10.9348 9.88478H10.2733V9.25793C10.2733 8.93481 10.0113 8.67285 9.68817 8.67285C9.36505 8.67285 9.10309 8.93481 9.10309 9.25793V9.88478H8.40295C8.07983 9.88478 7.81787 10.1467 7.81787 10.4699C7.81787 10.793 8.07983 11.0549 8.40295 11.0549Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.54521 14.2242H9.75794C10.4693 14.2242 11.2251 14.1349 12.0045 13.9587C12.4367 13.8609 12.8986 13.8609 13.331 13.9587C14.1103 14.1349 14.866 14.2242 15.5775 14.2242H15.7921C17.8196 14.2242 19.4692 12.5747 19.4692 10.5471V10.4622C19.4692 8.43469 17.8196 6.78516 15.7921 6.78516H9.54522C7.51773 6.78516 5.86816 8.43469 5.86816 10.4622V10.5471C5.86816 12.5746 7.51768 14.2242 9.54521 14.2242ZM7.03831 10.4622C7.03831 9.07991 8.16291 7.95532 9.54521 7.95532H15.7921C17.1743 7.95532 18.299 9.07992 18.299 10.4622V10.5471C18.299 11.9294 17.1744 13.054 15.7921 13.054H15.5774C14.9527 13.054 14.2837 12.9744 13.589 12.8173C13.2883 12.7494 12.9783 12.7149 12.6677 12.7149C12.357 12.7149 12.047 12.7494 11.7464 12.8173C11.0516 12.9744 10.3826 13.054 9.7579 13.054H9.54517C8.1629 13.054 7.03827 11.9294 7.03827 10.5471L7.03831 10.4622Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.4977 12.3801C15.8208 12.3801 16.0828 12.1182 16.0828 11.795C16.0828 11.4719 15.8208 11.21 15.4977 11.21C15.1745 11.21 14.9126 11.4719 14.9126 11.795C14.9126 12.1182 15.1745 12.3801 15.4977 12.3801Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.172 11.0549C14.4951 11.0549 14.7571 10.793 14.7571 10.4698C14.7571 10.1467 14.4951 9.88477 14.172 9.88477C13.8489 9.88477 13.5869 10.1467 13.5869 10.4698C13.5869 10.793 13.8489 11.0549 14.172 11.0549Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.4977 9.72973C15.8208 9.72973 16.0828 9.46778 16.0828 9.14465C16.0828 8.82152 15.8208 8.55957 15.4977 8.55957C15.1745 8.55957 14.9126 8.82152 14.9126 9.14465C14.9126 9.46778 15.1745 9.72973 15.4977 9.72973Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.8234 11.0549C17.1465 11.0549 17.4084 10.793 17.4084 10.4698C17.4084 10.1467 17.1465 9.88477 16.8234 9.88477C16.5002 9.88477 16.2383 10.1467 16.2383 10.4698C16.2383 10.793 16.5002 11.0549 16.8234 11.0549Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default VideosGamesIcon;
